<div *ngIf="showFilterRow">
  <form [formGroup]="filtersForm" class="table-filter-row">
    <ng-container *ngFor="let col of columns">
      <div [ngClass]="col.className">
        <lms-question *ngIf="col.name" [question]="filters[col.name].question" [form]="filtersForm"></lms-question>
      </div>
    </ng-container>
  </form>
</div>
